import { t } from 'services/translation';

export const DatePickerTranslationSettings = {
  previousMonth: t('LAST_MONTH'),
  nextMonth: t('NEXT_MONTH'),
  months: [
    t('JANUARY'),
    t('FEBRUARY'),
    t('MARCH'),
    t('APRIL'),
    t('MAY'),
    t('JUNE'),
    t('JULY'),
    t('AUGUST'),
    t('SEPTEMBER'),
    t('OCTOBER'),
    t('NOVEMBER'),
    t('DECEMBER'),
  ],
  weekdays: [
    t('SUNDAY'),
    t('MONDAY'),
    t('TUESDAY'),
    t('WEDNESDAY'),
    t('THURSDAY'),
    t('FRIDAY'),
    t('SATURDAY'),
  ],
  weekdaysShort: [
    t('SUN'),
    t('MON'),
    t('TUE'),
    t('WED'),
    t('THU'),
    t('FRI'),
    t('SAT'),
  ],
};
